  <!-- MINIMAP -->
  <div id="minimap" class="w-44 h-32 m-4 absolute bottom-0 left-0 z-[1] rounded-2xl overflow-hidden bg-lugano-gray" [class]="currentMap === 'seatmap' ? 'pointer-events-auto' : 'opacity-0 pointer-events-none'">
    <dvm-map-viewer [service]="viewersService.minimap"></dvm-map-viewer>
  </div>

  <!-- MINIMAP -->
  <!-- <div id="minimap" class="w-80 h-60 absolute bottom-0 left-0 z-[2] bg-amber-200" [class]="status.minimap.show ? 'pointer-events-auto' : 'opacity-0 pointer-events-none'">
    <dvm-navigable-minimap #minimapDom [linkedMapViewer]="viewersService.viewer"></dvm-navigable-minimap>
  </div> -->